export default __webpack_public_path__ + "static/media/Maria_resume.a44971b5.pdf";